import cleanUpObject from '../cleanUpObject';
import { excludedKeys } from '../advancedSearch';

export const mapRouteStopToSite = (stop) => {
  return {
    coords: {
      lat: stop.location.latitude,
      lng: stop.location.longitude,
    },
    id: stop.site_id,
    name: stop.site_name,
    priority: stop.priority,
    location_id: stop.location.id,
    address1: stop.location.address1,
    address2: stop.location.address2,
    city: stop.location.city,
    county: stop.location.county,
    state: stop.location.state,
    zip_code: stop.location.zip_code,
    arrival: stop.arrival,
    departure: stop.departure,
    h2a: stop.h2a,
    icon: stop.icon,
    last_visit: stop.last_visit,
    status: stop.status,
    worker_count: stop.worker_count,
  };
};

export const cleanParams = (params) => {
  const cleanedParams = { ...params };
  cleanUpObject(cleanedParams);
  excludedKeys.forEach((key) => {
    delete cleanedParams[key];
  });
  return cleanedParams;
};
